import { useEffect, useState } from "react";
import { getAsignacionesByUserId } from "../functions/api/asignacionNaves";

function useNavesAsignadas(token, idUsuario, reload) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    getAsignacionesByUserId(token, { id: idUsuario })
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => setError(err))
      .finally(() => setLoading(false));
  }, [idUsuario, reload]);

  return { data, loading, error };
}

export default useNavesAsignadas;
